/**
 * Page-level semantic size tokens from Figma. Values are raw numbers (px).
 * Exposed at the top of the theme — `theme.layout.normal.mainSideMargin`.
 *
 * Component-level sizes live in `component-sizes.ts`.
 */
import type { Sizes } from '../types';
import { spacingRaw } from './sizes';

export interface LayoutSize {
    mainSideMargin: number;
    mainTopMargin: number;
    mainBottomMargin: number;
    sectionMargin: number;
    relatedItemsMargin: number;
    smallItemsPadding: number;
}

export interface SemanticSizes {
    layout: Record<Sizes, LayoutSize>;
}

export const semanticSizes: SemanticSizes = {
    layout: {
        xSmall: {
            mainSideMargin: spacingRaw(4),
            mainTopMargin: spacingRaw(8),
            mainBottomMargin: spacingRaw(8),
            sectionMargin: spacingRaw(6),
            relatedItemsMargin: spacingRaw(4),
            smallItemsPadding: spacingRaw(2),
        },
        small: {
            mainSideMargin: spacingRaw(4),
            mainTopMargin: spacingRaw(8),
            mainBottomMargin: spacingRaw(8),
            sectionMargin: spacingRaw(6),
            relatedItemsMargin: spacingRaw(4),
            smallItemsPadding: spacingRaw(2),
        },
        normal: {
            mainSideMargin: spacingRaw(4),
            mainTopMargin: spacingRaw(6),
            mainBottomMargin: spacingRaw(16),
            sectionMargin: spacingRaw(6),
            relatedItemsMargin: spacingRaw(4),
            smallItemsPadding: spacingRaw(2),
        },
        large: {
            mainSideMargin: spacingRaw(4),
            mainTopMargin: spacingRaw(8),
            mainBottomMargin: spacingRaw(8),
            sectionMargin: spacingRaw(6),
            relatedItemsMargin: spacingRaw(4),
            smallItemsPadding: spacingRaw(2),
        },
    },
};
